module.exports = __webpack_public_path__ + "img/point.3a0efbc8.svg";